// extracted by mini-css-extract-plugin
module.exports = {"grid":"br_b2","column":"br_gv","link":"br_d","title":"br_l","description":"br_F","darkMode":"br_cX"};